module.exports = __webpack_public_path__ + "static/media/YB5M03_1.24887e0a.jpg";